var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H171V341.994H0V-0.00585938Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 -0.00585938H513V341.994H342V-0.00585938ZM198.9 113.594H256V178.394H198.9V113.594Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.6 113.594V178.294V113.594ZM284.2 113.594V178.294V113.594ZM300.8 113.594V178.294V113.594Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.1 113.594V178.294H264.1V113.594H271.1ZM287.7 113.594V178.294H280.7V113.594H287.7ZM297.3 178.294V113.594H304.3V178.294H297.3Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.4 178.394V243.094V178.394ZM234.1 178.394V243.094V178.394ZM220.8 178.494V232.394V178.494ZM207.1 178.494V225.594V178.494Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.6 178.394V243.094H231.6V178.394H236.6ZM249.9 178.394V243.094H244.9V178.394H249.9ZM204.6 225.594V178.494H209.6V225.594H204.6ZM223.3 178.494V232.394H218.3V178.494H223.3Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.9 145.994L227.5 113.594L256 145.894L227.9 178.294L199.9 145.994Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.2 95.8942V188.094C182.2 222.394 209.5 242.294 230.8 252.594C230 253.994 255.9 260.894 255.9 260.894C255.9 260.894 281.8 253.994 281 252.594C302.4 242.294 329.6 222.494 329.6 188.094V95.8942H182.2ZM312.1 188.094C312.1 204.994 302.1 217.494 279.3 231.994C270.7 237.494 261.8 240.994 256 242.994C250.2 240.994 241.3 237.494 232.7 231.994C209.9 217.494 199.9 203.994 199.9 188.094V113.594H312.1V188.094Z",
    fill: "#BC8B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.4 188.894H293.9V197.494H264.4V188.894ZM264.4 206.494H293.9V215.094H264.4V206.494Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/AD.4e18cb1c5cdd320b77d1f2c837390722.svg";
export { ForwardRef as ReactComponent };